import React from 'react';

import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    marginBottom: theme.spacing(2),
  },
}));

export const SectionItem = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();
  return <Box className={classes.root}>{children}</Box>;
};
